import templateUrl from 'servicestack/auto-query/auto-query-footer.htm'
import basicController from 'servicestack/basic.controller.properties'

const Footer = {
    bindings: {
        db: '<ngModel',
        query: '<',
        hidePageSizes: '<',
        hidePageCount: '<',
        hideMessages: '<',
        iconSize: '@',
        messageClass: '@',
        onPage: '&'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    },
    transclude: {
        empty: '?footerEmpty',
        busy: '?footerBusy',
        left: '?footerLeft',
        right: '?footerRight'
    },
    controller($transclude) {
        basicController(this);
        this.isSlotFilled = (slot) => $transclude.isSlotFilled(slot);
        if (!this.query) this.query = this.db;
    }
};

export default Footer;